import { AgGridReact } from "ag-grid-react";
import React, { Component, createRef } from "react";
import { Nav, TabContainer, TabContent, TabPane } from "react-bootstrap";
import "./LenderRequest.css";
import RequestType from "./RequestType/RequestType"
import RequestSubType from "./RequestSubType/RequestSubType";
import RequestSubTypeDoc from "./RequestSubTypeDoc/RequestSubTypeDoc";

class LenderRequest extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeTab: "request-type",
      showGrid: true,
      gridOptions: undefined,
      rowData: undefined
    };
  }

  gridRef = createRef(null);

  gridState = {
    "request-type": {
      gridOptions: undefined,
      rowData: undefined
    },
    "request-sub-type": {
      gridOptions: undefined,
      rowData: undefined,
    },
    "request-sub-type-doc": {
      gridOptions: undefined,
      rowData: undefined,
    },
  };

  onTabSelect(tab) {
    if (!tab) {
      tab = this.state.activeTab;
    }

    this.setState({
      activeTab: tab,
      showGrid: !!this.gridState[tab],
      gridOptions: this.gridState[tab]?.gridOptions,
      rowData: this.gridState[tab]?.rowData,
    });
  }

  setGridOptions(options, tabKey) {
    this.gridState[tabKey].gridOptions = options
    this.onTabSelect();
  }

  setGridData(data, tabKey) {
    this.gridState[tabKey].rowData = data
    this.onTabSelect();
  }

  getRequestTypePane() {
    return <RequestType   gridRef={this.gridRef} setGridOptions={options => this.setGridOptions(options, "request-type")} 
    setGridData={data => this.setGridData(data, "request-type")}/>
  }

  getRequestSubTypePane() {
    return <RequestSubType  gridRef={this.gridRef} setGridOptions={options => this.setGridOptions(options, "request-sub-type")} 
    setGridData={data => this.setGridData(data, "request-sub-type")}/>
  }

  getRequestSubTypeDocPane() {
    return <RequestSubTypeDoc gridRef={this.gridRef} setGridOptions={options => this.setGridOptions(options, "request-sub-type-doc")} 
    setGridData={data => this.setGridData(data, "request-sub-type-doc")}/>
  }

  render() {
    return (
      <div style={{margin: "25px 25px 25px 0px"}}>
        <div>
          <TabContainer id="admin-list-tab" defaultActiveKey="request-type" onSelect={(k) => this.onTabSelect(k)}>
            <Nav variant="pills" className="admin-list-nav">
              <Nav.Item>
                <Nav.Link className="admin-list-link" eventKey="request-type">
                  Request Type
                </Nav.Link>
              </Nav.Item>

              <Nav.Item>
                <Nav.Link className="admin-list-link" eventKey="request-sub-type">
                  Request Subtype
                </Nav.Link>
              </Nav.Item>

            <Nav.Item>
                <Nav.Link className="admin-list-link" eventKey="request-sub-type-doc">
                  Document Configuration
                </Nav.Link>
              </Nav.Item>
            </Nav>
            <TabContent className="admins-content">
              <TabPane eventKey="request-type">{this.getRequestTypePane()}</TabPane>
              <TabPane eventKey="request-sub-type">{this.getRequestSubTypePane()}</TabPane>
              <TabPane eventKey="request-sub-type-doc">{this.getRequestSubTypeDocPane()}</TabPane>
            </TabContent>
          </TabContainer>

          {this.state.showGrid ? (
            <div style={{ clear: "both", height: "100%", width: "100%" }}>
              <div style={{ height: "438px", width: "100%", marginBottom: "20px" }}>
                <AgGridReact 
                  {...this.state.gridOptions} 
                  rowData={this.state.rowData} 
                  ref={this.gridRef} 
                />
              </div>
            </div>          
          ) : (<></>)}
        </div>
      </div>
    );
  }
}

export default LenderRequest;
